<div class="card integrador-container">
    <p-tabView>
        <p-tabPanel *ngIf="direitoVisualizarIntegradores" header="Integradores">
            <p-toolbar styleClass="mb-4 integrador-toolbar">
                <ng-template pTemplate="left">
                    <button pButton pRipple label="Novo" [disabled]="!direitoInserirIntegradores" icon="pi pi-plus"
                        class="p-button-success mr-2" (click)="openNew()"></button>
                </ng-template>

            </p-toolbar>

            <div class="integrador-table-wrapper" #tableWrapper>
                <p-table #dtIntegradores [value]="data" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
                    [paginator]="true" [rowHover]="true" dataKey="id"
                    currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros"
                    [showCurrentPageReport]="true" [globalFilterFields]="['id','descricao']"
                    [scrollable]="true" [scrollHeight]="scrollHeight">


                <ng-template pTemplate="caption">
                    <div class="flex p-flex-column p-flex-md-row align-items-center justify-content-between">
                        <h5 class="p-m-0">Integradores</h5>
                        <span class="p-input-icon-left mt-2 md:mt-0">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dtIntegradores.filterGlobal($event.target.value, 'contains')"
                                placeholder="Pesquisar..." />
                        </span>
                    </div>

                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 12%">Código</th>
                        <th style="width: 38%">Descrição</th>
                        <th style="width: 30%">Pessoa</th>
                        <th class="col-acoes" style="width: 20%; min-width: 120px">Ações</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-dt>
                    <tr>
                        <td><span class="p-column-title negrito">Código: </span>{{dt.id}}</td>
                        <td><span class="p-column-title negrito">Descrição: </span>{{dt.descricao}}</td>
                        <td><span class="p-column-title negrito">Pessoa: </span>{{dt.pessoa?.nome}}</td>
                        <td class="col-acoes" style="text-align: center; white-space: nowrap">
                            <span class="p-column-title negrito">Ações: </span>
                            <button pButton [disabled]="!direitoEditarIntegradores"
                                pRipple icon="pi pi-pencil" class="p-button-rounded p-button-primary mr-2"
                                pTooltip="Editar" (click)="edit(dt)"></button>
                            <button pButton [disabled]="!direitoExcluirIntegradores"
                                pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger"
                                pTooltip="Excluir integrador" (click)="confirmarExclusao(dt)"></button>
                        </td>
                    </tr>
                </ng-template>

                </p-table>
            </div>
        </p-tabPanel>
        <p-tabPanel *ngIf="direitoVisualizarTipos" header="Tipos">
            <p-toolbar styleClass="mb-4 integrador-toolbar">
                <ng-template pTemplate="left">
                    <button pButton pRipple [disabled]="!direitoInserirTipos" label="Novo"
                        icon="pi pi-plus" class="p-button-success mr-2" (click)="openNewTipo()"></button>
                </ng-template>
            </p-toolbar>

            <div class="integrador-table-wrapper" #tableWrapperTipo>
                <p-table #dtTipos [value]="dataTipo" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
                    [paginator]="true" [rowHover]="true" dataKey="id"
                    currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros"
                    [showCurrentPageReport]="true" [globalFilterFields]="['id','descricao', 'ativo']"
                    [scrollable]="true" [scrollHeight]="scrollHeightTipo">


                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="p-m-0">Tipos</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dtTipos.filterGlobal($event.target.value, 'contains')"
                                placeholder="Pesquisar..." />
                        </span>
                    </div>

                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th>Código
                        </th>
                        <th>Descrição
                        </th>
                        <th>Editar</th>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-dt>
                    <tr>
                        <td><span class="p-column-title negrito">Código: </span>{{dt.id}}</td>

                        <td><span class="p-column-title negrito">Descrição: </span>{{dt.descricao}}</td>



                        <td style="text-align: center;">
                            <span class="p-column-title negrito">Editar: </span>
                            <button pButton pRipple [disabled]="!direitoEditarTipos"
                                icon="pi pi-pencil" class="p-button-rounded p-button-primary mr-2"
                                (click)="editTipo(dt)"></button>
                        </td>



                    </tr>
                </ng-template>

                </p-table>
            </div>
        </p-tabPanel>
    </p-tabView>

</div>
<p-dialog header="Integrador" [(visible)]="displayModal" [modal]="true" [breakpoints]="{'960px': '75vw'}"
    [style]="{width: '75vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div [ngStyle]="{'margin': '7px'}">
        <form [formGroup]="form" class="p-fluid grid">

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="text" id="descricao" pInputText formControlName="descricao">
                    <label for="descricao">Descrição</label>
                </p-floatlabel>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">

                <label for="tipo_integracao_id">Tipo de integração</label>
                <p-dropdown inputId="tipo_integracao_id" appendTo="body" [filter]="true" optionLabel="descricao"
                    [options]="dataTipo" formControlName="tipo_integracao_id">
                </p-dropdown>


            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="text" id="frequencia_execucao" pInputText formControlName="frequencia_execucao">
                    <label for="frequencia_execucao">Frequencia execução</label>
                </p-floatlabel>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <label for="ultima_data_hora_envio">Data do ultimo envio</label>
                <input type="datetime-local" id="ultima_data_hora_envio" pInputText
                    formControlName="ultima_data_hora_envio">

            </div>

            <div class="field col-12 md:col-12 xl:col-12">

                <label for="status">Status</label>
                <p-dropdown inputId="status" appendTo="body" [filter]="true" [options]="dropDownStatus"
                    formControlName="status">
                </p-dropdown>

            </div>

            <div class="field col-12 md:col-12 xl:col-12">

                <label for="pessoa_integracao_id">Pessoa</label>
                <p-dropdown inputId="pessoa_integracao_id" appendTo="body" [filter]="true" [options]="dropDownPessoa"
                    formControlName="pessoa_integracao_id">
                </p-dropdown>

            </div>

            <div class="field col-12 md:col-12 xl:col-6">
                <label for="usuario_integracao">Usuário</label>
                <input type="text" id="usuario_integracao" pInputText formControlName="usuario_integracao">

            </div>
            <div class="field col-12 md:col-12 xl:col-6">
                <label for="senha_integracao">Senha</label>
                <input type="password" id="senha_integracao" pInputText formControlName="senha_integracao">

            </div>
            <div class="field col-12 md:col-12 xl:col-12">
                <label for="url">Url</label>
                <input type="text" id="url" pInputText formControlName="url">

            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="text" id="caminho" pInputText formControlName="caminho">
                    <label for="caminho">Caminho</label>
                </p-floatlabel>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="time" id="hora_flu" pInputText formControlName="hora_flu">
                    <label for="hora_flu">Hora FLU</label>
                </p-floatlabel>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="time" id="hora_plu" pInputText formControlName="hora_plu">
                    <label for="hora_plu">Hora PLU</label>
                </p-floatlabel>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="time" id="hora_limite_flu" pInputText formControlName="hora_limite_flu">
                    <label for="hora_limite_flu">Hora Limite FLU</label>
                </p-floatlabel>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="time" id="hora_limite_plu" pInputText formControlName="hora_limite_plu">
                    <label for="hora_limite_plu">Hora Limite FLU</label>
                </p-floatlabel>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="number" id="dias_retroativos_flu" pInputText formControlName="dias_retroativos_flu">
                    <label for="dias_retroativos_flu">Dias Retroativos FLU</label>
                </p-floatlabel>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="number" id="dias_retroativos_plu" pInputText formControlName="dias_retroativos_plu">
                    <label for="dias_retroativos_plu">Dias Retroativos PLU</label>
                </p-floatlabel>
            </div>

        </form>

    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="displayModal = false" label="Voltar"
            class="p-button-raised p-button-warning mr-2">
        </button>
        <button *ngIf="loading == false" pButton pRipple type="button" icon="pi pi-check" (click)="save()"
            label="Salvar" class="p-button-raised p-button-success"></button>
        <p-progressSpinner *ngIf="loading" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
            strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>

<!-- Modal de confirmação de exclusão quando há estações vinculadas -->
<p-dialog header="Excluir integrador?" [(visible)]="modalExcluirComEstacoes" [modal]="true"
    [style]="{width: '500px'}" [draggable]="false" [resizable]="false" [closable]="true"
    [dismissableMask]="false" (onHide)="fecharModalExcluirComEstacoes()">
    <div class="p-fluid" *ngIf="integradorParaExcluir && estacoesRelacionadas?.length">
        <p class="mb-3">
            Este integrador está vinculado à(s) seguinte(s) estação(ões):
        </p>
        <ul class="mb-3 p-pl-3">
            <li *ngFor="let est of estacoesRelacionadas"><strong>{{ est.nome }}</strong></li>
        </ul>
        <p class="mb-3">
            Ao excluir, os vínculos serão removidos (soft delete). Para evitar exclusões acidentais,
            digite <strong>Excluir integrador</strong> para confirmar.
        </p>
        <div class="field">
            <label for="input-excluir-integrador">Confirmação</label>
            <input id="input-excluir-integrador" type="text" pInputText
                [(ngModel)]="inputExcluirIntegrador"
                placeholder="Excluir integrador"
                [class.ng-invalid]="inputExcluirIntegrador && inputExcluirIntegrador !== textoConfirmacaoExclusao" />
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" label="Cancelar" icon="pi pi-times"
            class="p-button-text" (click)="fecharModalExcluirComEstacoes()"></button>
        <button pButton pRipple type="button" label="Excluir" icon="pi pi-trash"
            class="p-button-danger"
            [disabled]="inputExcluirIntegrador !== textoConfirmacaoExclusao"
            (click)="executarExclusaoComEstacoes()"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Tipo" [(visible)]="displayModalTipo" [modal]="true" [breakpoints]="{'960px': '75vw'}"
    [style]="{width: '75vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div [ngStyle]="{'margin': '7px'}">
        <form [formGroup]="formTipo" class="p-fluid grid">

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="text" id="descricao" pInputText formControlName="descricao">
                    <label for="descricao">Descrição</label>
                </p-floatlabel>
            </div>


        </form>

    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="displayModalTipo = false" label="Voltar"
            class="p-button-raised p-button-warning mr-2">
        </button>
        <button *ngIf="loading == false" pButton pRipple type="button" icon="pi pi-check" (click)="saveTipo()"
            label="Salvar" class="p-button-raised p-button-success"></button>
        <p-progressSpinner *ngIf="loading" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
            strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>
